import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { errorHandl, setFormDataV2 } from 'src/app/utils/network-utils';
import { catchError } from 'rxjs/operators';
import { urls } from 'src/app/utils/url-utils';

@Injectable({
  providedIn: 'root'
})
export class CompaniesService {

  constructor(private http: HttpClient,) { }


  getCompaniesList(status): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.GET_COMPANIES_LIST + "?accountStatus=" + status)
  }

  getMultiselecetCompanies(endPoint): Observable<any> {
    let params = new HttpParams();
    params = params.append('accountStatus', endPoint.status);
    params = params.append('isRemoveIAAL', endPoint.isRemoveIAAL);
    return this.http.get<any>(urls.BASE_URL + urls.GET_COMPANIES_LIST , {params});
  }


  savecompany(id, companyData): Observable<any> {
    const formData = setFormDataV2(companyData);

    if (id) {
      return this.http.put<any>(urls.BASE_URL + urls.GET_COMPANIES_LIST + '/' + id, formData).pipe(
        catchError(errorHandl)
      );
    }
    else {
      return this.http.post<any>(urls.BASE_URL + urls.GET_COMPANIES_LIST, formData).pipe(
        catchError(errorHandl)
      );
    }
  }


  getCompanyById(id): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.GET_COMPANIES_LIST + `/${id}`)
  }

  getCompanyToken(Id,type?) {
    if (type) {
      const params = new HttpParams({ fromObject: { roleType: type } });
      return this.http.get(urls.BASE_URL + urls.GET_COMPANY_TOKEN + '/' + Id, { params });
    } else {
      return this.http.get(urls.BASE_URL + urls.GET_COMPANY_TOKEN + '/' + Id);
    }
  }

  // TODO: TEMPORARY — pointed at an ngrok tunnel for testing while the real endpoint
  // isn't reachable from BASE_URL. Revert to `urls.BASE_URL + urls.STAFF_LOGINS_URL`
  // and drop the ngrok-skip-browser-warning header below.
  private readonly TEMP_STAFF_LOGIN_BASE_URL = 'https://relieve-derived-haziness.ngrok-free.dev/api/';
  private readonly TEMP_NGROK_HEADERS = new HttpHeaders({ 'ngrok-skip-browser-warning': 'true' });

  getCompanies(status): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.GET_COMPANIES_LIST + "?accountStatus=" + status + '&isByPassId=true')
  }

  createStaffLogin(payload: any): Observable<any> {
    return this.http.post<any>(this.TEMP_STAFF_LOGIN_BASE_URL + urls.STAFF_LOGINS_URL, payload, { headers: this.TEMP_NGROK_HEADERS }).pipe(
      catchError(errorHandl)
    );
  }

  getAccountLinks(): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.ACCOUNT_LINKS_URL).pipe(
      catchError(errorHandl)
    );
  }

  createAccountLink(payload: any): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.ACCOUNT_LINKS_URL, payload).pipe(
      catchError(errorHandl)
    );
  }

  deleteAccountLink(accountLinkId: string): Observable<any> {
    return this.http.delete<any>(urls.BASE_URL + urls.ACCOUNT_LINKS_URL + '/' + accountLinkId).pipe(
      catchError(errorHandl)
    );
  }

  signInAccountLink(payload: any): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.ACCOUNT_LINKS_SIGNIN_URL, payload).pipe(
      catchError(errorHandl)
    );
  }

  getStaffLogins(): Observable<any> {
    return this.http.get<any>(this.TEMP_STAFF_LOGIN_BASE_URL + urls.STAFF_LOGINS_URL, { headers: this.TEMP_NGROK_HEADERS }).pipe(
      catchError(errorHandl)
    );
  }


}


